import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import Tag, { newTag } from "../../models/tag";
import TagForm from "./TagForm";

interface TagUpdateModalProps {
  show: boolean;
  tag?: Tag;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TagUpdateModal: React.FC<TagUpdateModalProps> = ({
  show,
  tag,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialTag, setInitialTag] = useState<Tag>(tag ? tag : newTag());

  const modalTitle = tag
    ? `Editar Tag de documento: ${tag.name}`
    : `Crear Tag de documento nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialTag(newTag());
    onCancel();
  };
  useEffect(() => {
    setInitialTag(tag ? tag : newTag());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <TagForm
            initialTag={initialTag}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TagUpdateModal;
